// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}
._1o9zkb7n{flex-shrink:1}
._2hwx12x7{margin-right:var(--ds-space-075,6px)}
._i0dlf1ug{flex-basis:0%}
._p12fr0r7{max-width:250px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/modal/basic-search-input/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,aAAa;AACxB,WAAW,oCAAoC;AAC/C,WAAW,aAAa;AACxB,WAAW,eAAe","sourcesContent":["._16jlkb7n{flex-grow:1}\n._1o9zkb7n{flex-shrink:1}\n._2hwx12x7{margin-right:var(--ds-space-075,6px)}\n._i0dlf1ug{flex-basis:0%}\n._p12fr0r7{max-width:250px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
